import React from "react"
import { User } from "firebase/auth"
import { SpaceKey } from "popopo-msg"
import { api } from "../../core"

export const SpaceMutedForm = (props: { firebase: User; spaceKey: SpaceKey }) => {
  const onMutedChange = async (muted: boolean) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.PUT("/api/v2/spaces/{space_key}/users/me/connection/muted", {
        params: { path: { space_key: props.spaceKey } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          muted,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <button type="button" className="btn btn-primary form-control" onClick={() => onMutedChange(true)}>
          Mute
        </button>
        <button type="button" className="btn btn-danger form-control" onClick={() => onMutedChange(false)}>
          Unmute
        </button>
      </form>
    </>
  )
}
